// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estils específics de la pestanya "Resum" de Gestió d'un Empleat. Totes
   les classes van prefixades amb "resum-emp-" perquè no afectin cap altra
   pantalla: per revertir-ho n'hi ha prou en eliminar aquest fitxer i el seu
   import a ResumEmpleat.js. */

.resum-emp-nav {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 12px;
  margin: 4px 0 16px;
}

.resum-emp-data {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #555;
}

.resum-emp-data input {
  font-size: 14px;
  padding: 4px 6px;
}

.resum-emp-any {
  font-size: 20px;
  font-weight: bold;
  min-width: 60px;
  text-align: center;
}

.resum-emp-error {
  color: #d9534f;
  font-weight: bold;
}

.resum-emp-targeta {
  background-color: #ffffff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 14px 16px;
  margin-bottom: 14px;
}

.resum-emp-targeta-titol {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
  color: #333;
}

.resum-emp-xifres {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.resum-emp-xifra {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 90px;
}

.resum-emp-xifra-valor {
  font-size: 18px;
  font-weight: bold;
}

.resum-emp-xifra-etiqueta {
  font-size: 12px;
  color: #777;
}

.resum-emp-xifra-pendent .resum-emp-xifra-valor {
  color: #d9534f;
}

.resum-emp-xifra-excedent .resum-emp-xifra-valor {
  color: #0099cc;
}

.resum-emp-desviacio-mes {
  font-weight: 900;
}

.resum-emp-desviacio-menys {
  color: #c0392b;
  font-weight: 400;
}

.resum-emp-linia {
  font-size: 13px;
  margin: 0 0 6px;
}

.resum-emp-desplegable {
  background: none;
  border: none;
  color: #0099cc;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
}

.resum-emp-desplegable:hover {
  text-decoration: underline;
}

.resum-emp-llista-dates {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.resum-emp-llista-dates li {
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  background-color: #f1f1f1;
}

.resum-emp-llista-dates li.resum-emp-futur {
  background-color: #e6f6fc;
  color: #007ba3;
}

.resum-emp-nota {
  font-size: 12px;
  color: #777;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/resumempleat.css"],"names":[],"mappings":"AAAA;;;8BAG8B;;AAE9B;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB","sourcesContent":["/* Estils específics de la pestanya \"Resum\" de Gestió d'un Empleat. Totes\n   les classes van prefixades amb \"resum-emp-\" perquè no afectin cap altra\n   pantalla: per revertir-ho n'hi ha prou en eliminar aquest fitxer i el seu\n   import a ResumEmpleat.js. */\n\n.resum-emp-nav {\n  display: flex;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 4px 0 16px;\n}\n\n.resum-emp-data {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  color: #555;\n}\n\n.resum-emp-data input {\n  font-size: 14px;\n  padding: 4px 6px;\n}\n\n.resum-emp-any {\n  font-size: 20px;\n  font-weight: bold;\n  min-width: 60px;\n  text-align: center;\n}\n\n.resum-emp-error {\n  color: #d9534f;\n  font-weight: bold;\n}\n\n.resum-emp-targeta {\n  background-color: #ffffff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 14px 16px;\n  margin-bottom: 14px;\n}\n\n.resum-emp-targeta-titol {\n  font-weight: bold;\n  font-size: 14px;\n  margin-bottom: 10px;\n  color: #333;\n}\n\n.resum-emp-xifres {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.resum-emp-xifra {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 90px;\n}\n\n.resum-emp-xifra-valor {\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.resum-emp-xifra-etiqueta {\n  font-size: 12px;\n  color: #777;\n}\n\n.resum-emp-xifra-pendent .resum-emp-xifra-valor {\n  color: #d9534f;\n}\n\n.resum-emp-xifra-excedent .resum-emp-xifra-valor {\n  color: #0099cc;\n}\n\n.resum-emp-desviacio-mes {\n  font-weight: 900;\n}\n\n.resum-emp-desviacio-menys {\n  color: #c0392b;\n  font-weight: 400;\n}\n\n.resum-emp-linia {\n  font-size: 13px;\n  margin: 0 0 6px;\n}\n\n.resum-emp-desplegable {\n  background: none;\n  border: none;\n  color: #0099cc;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 0;\n}\n\n.resum-emp-desplegable:hover {\n  text-decoration: underline;\n}\n\n.resum-emp-llista-dates {\n  list-style: none;\n  margin: 8px 0 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.resum-emp-llista-dates li {\n  font-size: 12px;\n  padding: 2px 8px;\n  border-radius: 4px;\n  background-color: #f1f1f1;\n}\n\n.resum-emp-llista-dates li.resum-emp-futur {\n  background-color: #e6f6fc;\n  color: #007ba3;\n}\n\n.resum-emp-nota {\n  font-size: 12px;\n  color: #777;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
